import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { KIND } from "../../lib/autoreg";

const ACTION = {
  auto_reduce: "Reducción automática", auto_progress: "Progresión automática", auto_transition: "Vuelta progresiva al plan", auto_cleared: "Ajuste retirado (vuelve la base)",
  coach_edit: "Editada por el entrenador", coach_revert: "Revertida a la base por el entrenador", coach_reviewed: "Revisada por el entrenador",
  proposal: "Recálculo propuesto (pendiente)", proposal_accepted: "Recálculo aceptado", proposal_rejected: "Recálculo rechazado: se mantiene la edición",
};
const Q = { sleep_hours: "sueño h", sleep_quality: "calidad", stress: "estrés", muscle_fatigue: "fatiga musc.", general_fatigue: "fatiga gral.", mood: "ánimo", readiness_to_train: "disposición", pain: "dolor", rpe_last_session: "RPE última" };

const Entry = ({ h }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "7px 0", fontSize: 13 }} data-testid={`ar-hist-${h.id}`}>
      <button onClick={() => setOpen(!open)} style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", padding: 0, textAlign: "left", fontSize: 13, width: "100%" }} data-testid={`ar-hist-toggle-${h.id}`}>
        <span style={{ color: "#737373" }}>{h.at.slice(0, 16).replace("T", " ")}</span> · <b>{h.client_name}</b> · sesión {h.session_date} {h.session_title || ""} · <span style={{ color: h.action.startsWith("coach") || h.action.startsWith("proposal_") ? "#60a5fa" : "#facc15" }}>{ACTION[h.action] || h.action}</span>{h.by ? ` · ${h.by}` : ""}
      </button>
      {open && (
        <div style={{ color: "#d4d4d4", marginTop: 6, lineHeight: 1.6 }} data-testid={`ar-hist-detail-${h.id}`}>
          {h.kind && <div>Tipo: {KIND[h.kind] || h.kind}</div>}
          {h.checkin && <div>Cuestionario {h.checkin.local_date}: {Object.entries(Q).map(([k, l]) => `${l} ${h.checkin[k] ?? "—"}`).join(" · ")}</div>}
          {h.changes?.length > 0 ? h.changes.map((c, i) => <div key={i}>{c.name}: {c.label} {c.before || "—"} → {c.after}</div>) : <div>Sin cambios sobre la sesión base.</div>}
          {h.reason && <div style={{ color: "#a3a3a3" }}>Motivo: {h.reason}</div>}
          {h.rules_triggered?.length > 0 && <div style={{ color: "#a3a3a3" }}>Reglas activadas: {h.rules_triggered.join(" · ")}</div>}
          {h.note && <div style={{ color: "#a3a3a3" }}>Nota: {h.note}</div>}
        </div>
      )}
    </div>
  );
};

export const HistoryTab = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/autoreg/history?limit=200").then((r) => setItems(r.data)).catch((e) => toast.error(formatErr(e))); }, []);
  if (!items) return <div style={{ color: "#a3a3a3" }}>Cargando…</div>;
  return (
    <div className="qv-card-app" style={{ padding: 16 }} data-testid="ar-history">
      <div style={{ fontWeight: 800, marginBottom: 6 }}>Historial de ajustes ({items.length})</div>
      {!items.length && <div style={{ fontSize: 13, color: "#a3a3a3" }}>Todavía no hay ajustes registrados.</div>}
      {items.map((h) => <Entry key={h.id} h={h} />)}
    </div>
  );
};
